const breakpointValues: Record<string, number> = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

const breakpointDownValues: Record<string, number> = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 5000,
};

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export const respond = {
  up: (bp: Breakpoint, styles: string): string => {
    return `@media (min-width: ${breakpointValues[bp]}px) { ${styles} }`;
  },
  down: (bp: Breakpoint): string => {
    return `@media (max-width: ${breakpointDownValues[bp]}px)`;
  },
};
